module.exports = __webpack_public_path__ + "static/img/tp.8a6c75bd.png";